import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import SellIcon from "@material-ui/icons/LocalOffer";
import PeopleIcon from "@material-ui/icons/People"
import ForumIcon from "@material-ui/icons/Forum"
import SecurityIcon from "@material-ui/icons/Security"
import LogoutIcon from "@material-ui/icons/ExitToApp"
import AssignmentIcon from "@material-ui/icons/Assignment"
import MenuItem from "@material-ui/core/MenuItem";
// import PaymentIcon from '@material-ui/icons/Payment';
// import MoneyIcon from './images/pound-sterling.js'

// import AccountBalance from "@material-ui/icons/AccountBalance";
// import FilterList from "@material-ui/icons/FilterList";
// import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
// import SwapHoriz from "@material-ui/icons/SwapHoriz";
// import SwapVert from "@material-ui/icons/SwapVert";
// import Motorcycle from "@material-ui/icons/Motorcycle";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Footer from "./components/Footer";
import UntiedAppBar from "./appbar";
import { isMobile } from 'react-device-detect';
import { Link  } from "react-router-dom";
import { Mixpanel } from "./mixpanel";
import "./index.css";

let view = window.location.pathname.replace("/","");
view = ""; // to be removed once we decide to implement the highlight

export default function MiniDrawer(props) {
  const classes = useStyles();
  const drwr = isMobile ? true : localStorage.getItem("DRAWEROpen") === "true";
  const [closed, setClosed] = React.useState(drwr);
  const rotate = closed ? "rotate(180deg)" : "rotate(360deg)";

  function handleDrawerOpen() {
    setClosed(false);
    localStorage.setItem("DRAWEROpen", false);
    Mixpanel.track("open drawer");
  }

  function handleDrawerClose() {
    setClosed(true);
    localStorage.setItem("DRAWEROpen", true);
    Mixpanel.track("close drawer");
  }

  function setActiveView(param) {
    view = param;
    // if (window.location.pathname == "/taxForms" && param == "taxForms"){
    // window.location.replace(`/${param}`)
    // }
    view = "" // to be removed once we decide to implement the highlight
}

    function handleMenuLogout() {
      localStorage.clear()
    };


  return (
    <div>
      <UntiedAppBar
        // position=“fixed”
        className={clsx(classes.appBar, {
          [classes.appBarShift]: drwr
        })}
        open={!closed}
      />

      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: !closed,
          [classes.drawerClose]: closed
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: !closed,
            [classes.drawerClose]: closed
          })
        }}
      >

        <div className="menu-icon-container">
          {!closed && (<div className="untied-logo" />)}
          {closed && (<div className="untied-tax-berry" />)}
        </div>

        <div className="menu-icon-container" style={{ height: 60, marginBottom: "10px" }}>
          {!closed && <div style = {{width: "100%", textAlign: "left", paddingLeft: "10px"}}>Personal adviser code <br/>{localStorage.getItem("agent_code")}
          <br />ARN: {localStorage.getItem("arn")??""}</div>}
          <IconButton onClick={closed ? handleDrawerOpen : handleDrawerClose}>
            <ChevronLeftIcon style={{ transform: rotate, transition: "all .3s ease" }}/>
          </IconButton>
        </div>
        
        <Divider />
        <MenuItem component={Link} to="/clients" className={view === "clients" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("accounts")}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <span className="item-label">Clients</span>
        </MenuItem>

        <Divider />
        <MenuItem component={Link} to="/tags" className={view === "clients" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("accounts")}>
          <ListItemIcon>
            <SellIcon />
          </ListItemIcon>
          <span className="item-label">Tags</span>
        </MenuItem>        

        <MenuItem component={Link} to="/mtdauths" className={view === "mtdauths" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("mtdauths")}>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <span className="item-label">MTD Auth Requests</span>
        </MenuItem>

        <MenuItem component={Link} to="/settings" className={view === "settings" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("settings")}>
          <ListItemIcon>
            <SecurityIcon />
          </ListItemIcon>
          <span className="item-label">Settings</span>
        </MenuItem>

        <MenuItem
          onClick={() => { window.open("https://help.untied.io/", "_blank") }}
          to="https://help.untied.io/"
          target="_blank"
          className="menu-item-default"
        >
          <ListItemIcon>
            <ForumIcon />
          </ListItemIcon>
          Get help
        </MenuItem>


        <Divider />

        <MenuItem 
        component={Link} to="/login" 
        onClick={handleMenuLogout}
        className="menu-item-default">
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        Log out
        </MenuItem>
      {!closed && <div style={{width: "100%", position: "absolute", bottom: "5px"}}>
      <Footer/>
      </div>}
      </Drawer>
    </div>
  ); 
}
const drawerWidth = 240;
// eslint-disable-next-line
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "#0c90b2"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: 2000
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    //marginRight: 36,
    marginRight: theme.spacing(2)
  },
  hide: {
    display: "none"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap"
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: 'cubic-bezier(0.42, 0, 0.58, 1.0)',
      duration: 400
    })
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: 'cubic-bezier(0.42, 0, 0.58, 1.0)',
      duration: 400
    }),
    overflow: "hidden",
    width: theme.spacing(7) + 1
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    height: 50,
    ...theme.mixins.toolbar
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    justifyContent: "flex-end"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  }
}));
